import React from 'react';
import { get } from 'lodash';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';

export default class ModalReject extends React.Component {
	constructor(props) {
		super(props);
		this.state ={
			startDate : moment(),
			minDate: moment(),
			maxDate: null,
			ActiveDataModal: null,
			message: '',
		}
		this.handleMessageChange = this.handleMessageChange.bind(this);
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.activeDataModal != null) {
			if (nextProps.activeDataModal.hasOwnProperty('Asset')){
				nextState.ActiveDataModal = nextProps.activeDataModal;
			}
			return true;
		}
		return false;
	}

	handleMessageChange(evt) {
		this.setState({
			message: evt.target.value
		});
	}

	renderField(type) {
		const {selectedItem} = this.props
		let element = []
		if(get(selectedItem, 'length', 0) > 0) {
			for(let i = 0; i < selectedItem.length; i++) {
				if(type === 'asset') {
					element.push(
						<div className="bulk-item-in-modal" style={{'marginBottom': '-1rem'}} key={selectedItem[i].Asset.Alias}>
							<input type="text" className="form-control" style={{backgroundColor:'#ebebeb', cursor:'default'}} value={'Asset : ' + selectedItem[i].Asset.Name} readOnly/>
							<input type="text" className="form-control" style={{backgroundColor:'#ebebeb', cursor:'default'}} value={'From : ' + selectedItem[i].Accessed.CreatedBy} readOnly/>
							<div className="bulk-item-in-modal-box-remove">
								<button title="Remove selected bulk" onClick={()=>this.props.removeBulkFromModal(selectedItem[i].Alias)} 
								className="bulk-item-in-modal-remove btn-sm btn btn-danger "><span aria-hidden="true">×</span></button>
							</div>
						</div>
					)

				}
			}
		} else {
			if(type === 'asset') {
				element = <input type="text" className="form-control" value={this.state.ActiveDataModal.Asset.Name} readOnly/>
			} else if(type === 'from') {
				element = <input type="text" className="form-control" value={this.state.ActiveDataModal.Accessed.CreatedBy} readOnly/>
			}
		}
		return element
	}
	
	render() {
		const {selectedItem} = this.props
		if(this.state.ActiveDataModal == null) {
			return(null);
		}
		let ok_text, title_text, asset_text = null

		if(get(selectedItem, 'length', 0) > 0) {
			title_text= "Bulk Reject Reasign"
			ok_text = `Reject ${selectedItem.length} assets`
			asset_text = "List of assets"
		} else {
			title_text = "Reject Reasign"
			ok_text = "Reject"
			asset_text = "Asset"
		}

		return (
			<Modal isOpen={this.props.isOpen} toggle={()=>this.props.toogleModalReject(this.state.ActiveDataModal)}>
				<ModalHeader>{title_text}</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="form-group col-sm-12">
							<label>{asset_text}</label>
							{this.renderField('asset')}
						</div>
						{get(selectedItem, 'length', 0) <= 0 && 
							<div className="form-group col-sm-12">
								<label>From</label>
								{this.renderField('from')}
							</div>
						}
					</div>
					<div className="row">
						<div className="form-group col-sm-12">
							<label>Message</label>
							<textarea 
								name="Message" 
								rows="5" 
								className="form-control" 
								placeholder="Enter Message Here" 
								value={this.state.message}
								onChange={this.handleMessageChange}
							></textarea>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={(e)=>this.props.toogleModalReject(this.state.ActiveDataModal)}>Cancel</Button>
					<Button color="primary" onClick={()=>this.props.confirmationAnswer("reject", this.state)}>{ok_text}</Button>
				</ModalFooter>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/Modal/ModalReject.js